import firebase from 'firebase';

import View from '../_components/view/view.js';
import accountBoxTpl from './account-box.tpl.html';
import './account-box.styles.less';

class SectionsBarView extends View {

	constructor (data, options) {
		
		super(accountBoxTpl, data, options);
		
		this.setFirebaseUIConfig();
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			signOutBtn: 'button.sign-out',
			accountDetails: '.account-details',
			userImage: '.user-image',
			userDisplayName: '.user-display-name'
		});
	}

	render(data) {
		super.render(data);

		//this.ui.closeBtn.click(() => this.closeHandler());

	}

	renderUserDetails() {
		this.ui.userImage.css('background-image', 'url(' + this.accountDetails.providerData[0].photoURL + ')');
		this.ui.userDisplayName.text(this.accountDetails.displayName);
	}

	onShow() {
		this.startFirebaseUI();
	}

	setFirebaseUIConfig() {
		// FirebaseUI config.
		this.firebaseUIConfig = {
			//signInSuccessUrl: '<url-to-redirect-to-on-success>',
			callbacks: {
				signInSuccess: function(currentUser, credential, redirectUrl) {
					console.log('signed in!');
					return false; //Needed if you don't want to specify signInSuccessUrl'
				}
			},
			signInOptions: [
				firebase.auth.FacebookAuthProvider.PROVIDER_ID,
				// Leave the lines as is for the providers you want to offer your users.
				/*firebase.auth.GoogleAuthProvider.PROVIDER_ID,
				firebase.auth.TwitterAuthProvider.PROVIDER_ID,
				firebase.auth.GithubAuthProvider.PROVIDER_ID,
				firebase.auth.EmailAuthProvider.PROVIDER_ID*/
			],
			// Terms of service url.
			tosUrl: ''
		};
	}

	startFirebaseUI () {
		firebase.auth().onAuthStateChanged( user => {
			if (user) {
				// User is signed in.
				this.ui.accountDetails.removeClass('hidden');

				user.getToken().then(accessToken => {
					this.accountDetails = {
						displayName: user.displayName,
						email: user.email,
						emailVerified: user.emailVerified,
						photoURL: user.photoURL,
						userId: user.uid,
						accessToken: accessToken,
						providerData: user.providerData
					};
					this.renderUserDetails();
					
					//Update user info in db
					firebase.database().ref('users/' + this.accountDetails.userId).set({
						displayName: user.displayName,
						email: user.email,
						photoURL: this.accountDetails.providerData[0].photoURL
					});
					//Update player info if exists
					firebase.database().ref('players/')
						.orderByChild('userId')
						.equalTo(this.accountDetails.userId)
						.limitToFirst(1)
						.once('child_added', __player => {
							if (__player.val()) {
								__player.ref.update({
									userId: this.accountDetails.userId,
									photoURL: this.accountDetails.providerData[0].photoURL
								});
							}
						});
				});

			} else {
				this.accountDetails = null;
				this.ui.accountDetails.addClass('hidden');

				// The start method will wait until the DOM is loaded.
				this.options.firebaseUI.start('#firebaseui-auth-container', this.firebaseUIConfig);
			}
		}, function(error) {
			console.log(error);
		});

		this.ui.signOutBtn.click(() => {
			firebase.auth().signOut().then(() => {
				console.log('Signed Out');
				this.ui.signOutBtn.show();
			}, function(error) {
				console.error('Sign Out Error', error);
			});
		});
	}

	remove() {
		super.remove();
		this.ui.signOutBtn.off();
	}

}

export default SectionsBarView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/account-box/account-box.view.js